import { render, staticRenderFns } from "./permalink_dropdown_item.vue?vue&type=template&id=14363de9"
import script from "./permalink_dropdown_item.vue?vue&type=script&lang=js"
export * from "./permalink_dropdown_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports